// extracted by mini-css-extract-plugin
module.exports = {"container":"_7a3fb80146--container--lw0U1","title":"_7a3fb80146--title--_Re3I","content":"_7a3fb80146--content--d5w96"};